import { useState, type FormEvent } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ApiError, apiPost } from "../api/client";
import { AuthLayout } from "../components/AuthLayout";

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (password !== confirm) {
      setError("Those passwords don't match.");
      return;
    }
    setError("");
    setLoading(true);
    try {
      await apiPost("/api/auth/reset-password", {
        token,
        new_password: password,
      });
      navigate("/login?reset=1", { replace: true });
    } catch (err) {
      setError(
        err instanceof ApiError ? err.message : "Couldn't reset the password"
      );
    } finally {
      setLoading(false);
    }
  }

  if (!token) {
    return (
      <AuthLayout
        title="Link incomplete"
        intro="This reset link is missing its token. Open the link from your email directly, or request a new one."
        footer={<Link to="/forgot-password">Request a new link</Link>}
      >
        <></>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Choose a new password"
      footer={
        <span className="auth-footer-note">
          Saving signs you out everywhere, so sign in again with the new
          password.
        </span>
      }
    >
      <form onSubmit={handleSubmit} className="auth-form">
        {error && (
          <div className="error" role="alert">
            {error}
          </div>
        )}
        <label>
          <span className="field-label">New password</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            minLength={6}
            autoComplete="new-password"
            autoFocus
            required
          />
          <span className="field-hint">At least 6 characters.</span>
        </label>
        <label>
          <span className="field-label">Confirm new password</span>
          <input
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            minLength={6}
            autoComplete="new-password"
            required
          />
        </label>
        <button type="submit" className="btn btn-primary btn-lg" disabled={loading}>
          {loading ? "Saving…" : "Save new password"}
        </button>
      </form>
    </AuthLayout>
  );
}
